import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Block = styled.div`
  display: flex;
  align-items: center;
`;
